module.exports = __webpack_public_path__ + "images/bannerDE-551b6ec1a1c40d352968b34216986029.jpg";